import { render, staticRenderFns } from "./header.html?vue&type=template&id=2f913065&scoped=true&external"
import script from "./header.js?vue&type=script&lang=js&external"
export * from "./header.js?vue&type=script&lang=js&external"
import style0 from "./header.css?vue&type=style&index=0&id=2f913065&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f913065",
  null
  
)

export default component.exports